'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var fastOrderDetailComponent = exports.fastOrderDetailComponent = {
    template: require('./detail.html'),
    controllerAs: 'vm',
    controller: ["cartService", "$scope", "$state", "toastr", "gettextCatalog", "productService", "common", "Analytics", function controller(cartService, $scope, $state, toastr, gettextCatalog, productService, common, Analytics) {
        'ngInject';

        var vm = this;
        vm.addProductToList = addProductToList;
        vm.deleteProductFromList = deleteProductFromList;
        vm.addToShoppingCart = addToShoppingCart;
        vm.clearList = clearList;
        vm.quantity = 1;
        vm.searchString = null;
        vm.isLoading = false;
        vm.products = [];
        vm.errors = {};
        vm.productNotfound = true;
        vm.stateName = null;
        vm.searchProducts = searchProducts;
        vm.productSearchChanged = productSearchChanged;
        vm.isAddingToCart = false;
        vm.hasFocus = true;
        vm.$onInit = init;
        $scope.forms = {};

        function init() {
            common.setTitle(gettextCatalog.getString('Fast Order'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/fast-order', gettextCatalog.getString('Fast Order'));
        }

        function searchProducts(query) {
            return productService.searchProducts(query, 10);
        }

        function productSearchChanged(item) {
            vm.selectedProduct = item;
        }

        // UPLOAD CSV
        $scope.$watch('vm.file', function () {
            if (vm.file) {
                uploadProductList();
            }
        });

        this.checkError = function (product) {
            if (product.hasQuantityError) {
                product.hasQuantityError = false;
            }
        };

        function uploadProductList() {
            vm.isLoading = true;
            vm.errors.fileUpload = false;
            vm.errors.shoppingCartAdd = false;

            productService.uploadProductList(vm.file).then(function (products) {
                products.forEach(function (product) {
                    vm.isLoading = false;

                    if (product.quantity <= 0) {
                        vm.errors.amount = true;
                    }
                    if (!product.quantity) {
                        vm.errors.quantity = true;
                    }
                    if (!product.name) {
                        vm.errors.productError = true;
                    }

                    //check if product is in list
                    var data = vm.products.find(function (elem) {
                        if (product.id === null) {
                            return null;
                        } else if (elem.id === product.id) {
                            elem.quantity += product.quantity;
                            return elem;
                        }
                    });

                    if (!data) {
                        vm.products.push(product);
                    }
                    //check for errors
                });
                if (!products.length) {
                    vm.isLoading = false;
                    vm.errors.emptyCsv = true;
                }
                Analytics.trackEvent('FastOrder', 'productListUploaded', 'productListUploaded', 0, true, { fileSize: vm.file.size + 'B' });
            }).catch(function (ex) {
                vm.isLoading = false;
                vm.errors.fileUpload = true;
                Analytics.trackException(ex, true);
            });
        }

        // PRODUCT OPERATIONS

        function addProductToList() {
            // Quickfix if no procduct is selected. trackjs issue (https://my.trackjs.com/shared/MTdlMGNmYThlNTg3NGZjNDk1MDY0MTFmYzg2YmVjMWY)
            if (!vm.selectedProduct) {
                return;
            }

            changeFocus();

            vm.errors.shoppingCartAdd = false;
            if (vm.quantity <= 0) {
                vm.errors.amount = true;
            } else {
                //check if product is in list
                var data = vm.products.find(function (elem, index) {
                    if (elem.id === vm.selectedProduct.id) {
                        elem.quantity += vm.quantity;
                        vm.products.splice(index, 1);
                        vm.products.unshift(elem);
                        return elem;
                    }
                });
                if (!data) {
                    vm.selectedProduct.quantity = vm.quantity;
                    vm.products.unshift(vm.selectedProduct);
                }

                vm.quantity = 1;
                vm.searchString = null;
                vm.selectedProduct = null;
                vm.errors.amount = false;
                vm.errors.fileUpload = false;
            }
        }

        function changeFocus() {
            vm.hasFocus === true ? vm.hasFocus = false : vm.hasFocus = true;
        }

        function deleteProductFromList(product) {
            vm.products.splice(vm.products.findIndex(function (elem) {
                return elem.id === product.id;
            }), 1);

            if (vm.products.length === 0) {
                vm.errors = {};
            }
        }

        function clearList() {
            vm.errors = {};
            vm.products = [];
        }

        function addToShoppingCart() {
            $scope.forms.productOverviewForm.$setPristine();
            vm.isAddingToCart = true;
            vm.productsForCart = [];
            vm.products.map(function (product) {
                if (product.name && product.name !== '' && product.nationalNumber && product.quantity) {
                    vm.productsForCart.push(product);
                }
            });

            vm.errors = {};
            vm.products = [];

            cartService.quickAddProducts(vm.productsForCart).then(function () {
                vm.productsForCart = [];
                vm.isAddingToCart = false;

                Analytics.trackEvent('FastOrder', 'addedFastOrderProductsToCart', 'addedFastOrderProductsToCart', 0, true, {});

                toastr.success(gettextCatalog.getString('Added products to your shoppingcart'), '', {
                    progressBar: true,
                    timeOut: 5000,
                    extendedTimeOut: 1000,
                    closeButton: true
                });

                $state.go('cart');
            }).catch(function () {
                toastr.error(gettextCatalog.getString('An error occured when adding products to your shoppingcart, please try again'), '', {
                    progressBar: true,
                    timeOut: 5000,
                    extendedTimeOut: 1000,
                    closeButton: true
                });

                vm.isAddingToCart = false;
                vm.errors.shoppingCartAdd = true;
            });
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/fast-order/detail.js
// module id = 932
// module chunks = 0